const randomInsideInterval = (min = 0, max) => Math.floor(Math.random() * (max - min + 1) + min);

export default randomInsideInterval;



// WEBPACK FOOTER //
// ../utils/functions/random.js